module.exports = "<i class=\"spark-icon--fill spark-icon-remove-circle circle-disabled-icon\" data-click=false uid={{::uid}} field-id={{::fieldId}}></i>";